export default __webpack_public_path__ + "static/media/Major Rune Stone of the Judgment Bolt (V).90b670dd.jpg";